import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './ui/feedback';
import { getApiErrorMessage } from './commerçant/ui/Feedback';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ToastProvider formatError={getApiErrorMessage}>
    <App />
  </ToastProvider>
);
